import React from "react";

function SvgGroupIconNew(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={props.width}
      height={props.height}
      viewBox="0 0 50 50"
      color="currentColor"
    >
      <defs>
        <clipPath id="clip-My_Group_1">
          <rect width="50" height="50" />
        </clipPath>
      </defs>
      <g
        id="My_Group_1"
        data-name="My Group – 1"
        clipPath="url(#clip-My_Group_1)"
      >
        <g id="Group_20050" data-name="Group 20050">
          <g
            id="Group_20009"
            data-name="Group 20009"
            transform="translate(36.825 27.218)"
          >
            <g id="Group_20008" data-name="Group 20008">
              <path
                id="Path_29233"
                data-name="Path 29233"
                d="M403.09,273.32h-4.6a11.955,11.955,0,0,1,.724,4.11V294.8a5.123,5.123,0,0,1-.3,1.716h7.6a5.153,5.153,0,0,0,5.147-5.147V281.9A8.589,8.589,0,0,0,403.09,273.32Z"
                transform="translate(-398.494 -273.32)"
                fill="currentColor"
              />
            </g>
          </g>
          <g
            id="Group_20011"
            data-name="Group 20011"
            transform="translate(0 27.218)"
          >
            <g id="Group_20010" data-name="Group 20010">
              <path
                id="Path_29234"
                data-name="Path 29234"
                d="M12.451,277.431a11.956,11.956,0,0,1,.724-4.11h-4.6A8.589,8.589,0,0,0,0,281.9v9.47a5.153,5.153,0,0,0,5.148,5.147h7.6a5.124,5.124,0,0,1-.3-1.716Z"
                transform="translate(0 -273.321)"
                fill="currentColor"
              />
            </g>
          </g>
          <g
            id="Group_20013"
            data-name="Group 20013"
            transform="translate(14.682 22.748)"
          >
            <g id="Group_20012" data-name="Group 20012">
              <path
                id="Path_29235"
                data-name="Path 29235"
                d="M151.551,234.815h-8.1c-3.649,0-6.617,3.849-6.617,8.579v17.371a1.558,1.558,0,0,0,1.323,1.716h18.692a1.558,1.558,0,0,0,1.323-1.716V243.394C158.168,238.664,155.2,234.815,151.551,234.815Z"
                transform="translate(-136.829 -234.815)"
                fill="currentColor"
              />
            </g>
          </g>
          <g
            id="Group_20015"
            data-name="Group 20015"
            transform="translate(15.964)"
          >
            <g id="Group_20014" data-name="Group 20014">
              <path
                id="Path_29236"
                data-name="Path 29236"
                d="M176.15,38.84a9.034,9.034,0,1,0,9.036,9.036A9.046,9.046,0,0,0,176.15,38.84Z"
                transform="translate(-167.114 -38.84)"
                fill="currentColor"
              />
            </g>
          </g>
          <g
            id="Group_20017"
            data-name="Group 20017"
            transform="translate(2.882 11.256)"
          >
            <g id="Group_20016" data-name="Group 20016">
              <path
                id="Path_29237"
                data-name="Path 29237"
                d="M40.315,121.689a6.869,6.869,0,1,0,6.872,6.872A6.88,6.88,0,0,0,40.315,121.689Z"
                transform="translate(-33.443 -121.689)"
                fill="currentColor"
              />
            </g>
          </g>
          <g
            id="Group_20019"
            data-name="Group 20019"
            transform="translate(32.754 11.256)"
          >
            <g id="Group_20018" data-name="Group 20018">
              <path
                id="Path_29238"
                data-name="Path 29238"
                d="M352.479,121.689a6.872,6.872,0,1,0,6.872,6.872A6.88,6.88,0,0,0,352.479,121.689Z"
                transform="translate(-345.607 -121.689)"
                fill="currentColor"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
export default React.memo(SvgGroupIconNew);
